<template>
  <div class="similar-search-button__top">
    <button
      type="button"
      class="header-sp__similar-search-btn"
      @click="openDialog"
    >
      <i class="material-icons" aria-hidden="true">edit_note</i>
      文章で検索する
    </button>

    <SimilarSearchDialog
      :visible="isDialogOpen"
      @close="isDialogOpen = false"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import SimilarSearchDialog from '../../../../similar_search/components/SimilarSearchDialog.vue';
import { trackSimilarSearch } from '../../../../similar_search/tracking';

const isDialogOpen = ref(false);

const openDialog = () => {
  trackSimilarSearch('click', '検索ボタン_検索バー');
  isDialogOpen.value = true;
};
</script>
